import { getLatestData } from '../Utils/GetLatestData'
import { WizardContext, WizardEvent } from '../wizardMachine'

export const isLastApplicant = (context: WizardContext, event: WizardEvent): boolean => {
  const { applicants } = getLatestData(context, event)
  if (applicants) {
    return context.index >= Object.keys(applicants).length - 1
  }
  return false
}
